import { AgeHoursTableData } from '../types';

import { AGE_HOURS } from 'RestAPIs/endpoints';
import { useCreateResource } from 'RestAPIs/useCreateResource';
import { useUpdateResource } from 'RestAPIs/useUpdateResource';

export const useCreateEditMutation = (
  handleClose: () => void,
  isCopied: boolean,
  rowData?: AgeHoursTableData
) => {
  const editAgeHour = useUpdateResource({
    id: rowData?.agelistId ?? '',
    url: AGE_HOURS,
    invalidateQueryKey: ['ageHours']
  });
  const createAgeHour = useCreateResource({
    url: AGE_HOURS,
    invalidateQueryKey: ['ageHours']
  });

  return rowData && !isCopied ? editAgeHour : createAgeHour;
};
